import { render } from "./PolicyChangesSection.vue?vue&type=template&id=1b1db034"
import script from "./PolicyChangesSection.vue?vue&type=script&lang=js"
export * from "./PolicyChangesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__